<template>
  <v-dialog v-model="isShow" persistent width="600">
    <v-card>
      <v-card-title style="word-break: break-word">{{
        event.name
      }}</v-card-title>
      <v-divider class="primary"></v-divider>
      <v-card-text class="mt-8"  style="font-size:16px!important">
        <v-row class="ml-1">Date: {{ event.start }} to {{ event.end }} </v-row>
        <v-row class="ml-1 pt-2">
          Note: {{ event.description }}
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="close">CLOSE</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EventViewer",
  props: { isShow: Boolean, event: Object },
  data: () => {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style>
</style>